
import axios from 'axios'
import React, { useState, useEffect } from 'react'
import { ToastContainer, toast } from 'react-toastify'
import { BASE_URL } from '../../config/axios'
import { AddDivision, DeleteDivision, UpdateDivision } from './AddDivision';



const Division = () => {
    const [division, setDivision] = useState([]);

    /** ========== Fetch Division Data ========== */
    const getDivisionData = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/detail-design/division/`);
            const divisions = res.data || [];
            setDivision(divisions);
            console.log("Divisions:", divisions);
        } catch (err) {
            console.error("Error fetching divisions:", err);
            toast.error("Failed to fetch division data!");
        }
    };


    useEffect(() => {
        getDivisionData();
    }, []);

    return (
        <div className="content-tabs">
            <div className="attendance-box">
                <div className="attendance-subcont-01">
                    <div className="field-cont"></div>
                    <div className="btn-cont">
                        <AddDivision getDevisionName={getDivisionData} />
                    </div>
                </div>

                <div className="datagrid-container">
                    <div className="table-css-white-background table-box paddingTop-0px scroll-container-table">
                        <table className="table-css">
                            <thead className="table-heading">
                                <tr className="custom-table-head-tr">
                                    <th className="table-heading-text">Sr no.</th>
                                    <th className="align-center table-heading-text">Division Code</th>
                                    <th className="align-center table-heading-text" style={{ width: "28%" }}>Division Name</th>
                                    <th className="align-left table-heading-text" style={{ width: "20%" }}>Activity </th>
                                    <th className="align-left  table-heading-text" style={{ width: "20%" }}>Sub-Activity</th>
                                    <th className="align-center">Actions</th>
                                </tr>
                            </thead>

                            <tbody>
                                {division.length > 0 ? (
                                    division.map((item, index) => (
                                        item.activity && item.activity.length > 0 ? (
                                            item.activity.map((act, actIndex) => (
                                                <tr key={`${item.id}-${act.id}`} className="custom-table-head-td-01">

                                                    {actIndex === 0 && (
                                                        <td rowSpan={item.activity.length} className="table-body align-center">
                                                            {index + 1}
                                                        </td>
                                                    )}

                                                    {actIndex === 0 && (
                                                        <td rowSpan={item.activity.length} className="table-body align-center">
                                                            {item.division_code}
                                                        </td>
                                                    )}

                                                    
                                                    {actIndex === 0 && (
                                                        <td rowSpan={item.activity.length} className="table-body align-center" style={{ width: "28%" }}>
                                                            {item.division_name}
                                                        </td>
                                                    )}

                                                    {/* Activity Column */}
                                                    <td className="table-body text-left align-top font-weight-bold">
                                                        {act.activity_code} - {act.activity_name}
                                                    </td>

                                                    {/* Sub-Activity Column */}
                                                    <td className="table-body text-left align-top">
                                                        {act.subactivities && act.subactivities.length > 0 ? (
                                                            act.subactivities.map((sub) => (
                                                                <div key={sub.id} className="pl-2">
                                                                    {sub.subactivity_code} - {sub.subactivity_name}
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <div className="text-muted pl-2">No Sub-Activity</div>
                                                        )}
                                                    </td>

                                                    {/* Actions (only on first activity row) */}
                                                    {actIndex === 0 && (
                                                        <td rowSpan={item.activity.length} className="table-body align-center">
                                                            <div className="flex-row" style={{ justifyContent: 'center' }}>
                                                                <DeleteDivision item={item} getActivity={getDivisionData} />
                                                            </div>
                                                        </td>
                                                    )}
                                                </tr>
                                            ))
                                        ) : (
                                            <tr key={item.id}>
                                                <td className="table-body align-center">{index + 1}</td>
                                                <td className="table-body align-center">{item.division_code}</td>
                                                <td className="table-body align-center">{item.division_name}</td>
                                                <td className="table-body text-center">No Activity</td>
                                                <td className="table-body text-center">No Sub-Activity</td>
                                                <td className="table-body align-center">
                                                    <div className="flex-row" style={{ justifyContent: 'center' }}>
                                                        <DeleteDivision item={item} getActivity={getDivisionData} />
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    ))
                                ) : (
                                    <tr>
                                        <td className="table-body text-center" colSpan={6}>
                                            No Divisions Found
                                        </td>
                                    </tr>
                                )}
                            </tbody>


                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};








export default Division;





